import { CampaignStatus, CampaignTypes } from '@shared/constants';
import { CampaignDTO } from '@shared/dto';

export class Campaign {
  campaignId: number;
  label: string;
  endDate: string;
  startDate: string;
  status: CampaignStatus;
  targetingEndDate?: string;
  typeCampaign: CampaignTypes;
  targetingStartDate?: string;
  maxGainPerCustomer?: number;
  deployOnCustomerPage?: string;

  constructor(obj: CampaignDTO) {
    this.label = obj.label;
    this.status = obj.status;
    this.endDate = obj.end_date;
    this.startDate = obj.start_date;
    this.campaignId = obj.campaign_id;
    this.typeCampaign = obj.type_campaign;
    this.targetingEndDate = obj.targeting_end_date;
    this.targetingStartDate = obj.targeting_start_date;
    this.maxGainPerCustomer = obj.max_gain_per_customer;
    this.deployOnCustomerPage = obj.deploy_on_customer_page;
  }

  get isCampaignOver(): boolean {
    return new Date(this.endDate) < new Date();
  }
}
